import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifzero_mpu_get',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_MPU_GET}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/RHHqXtx/ifzero.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'field_dropdown',
      name: 'MPU',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFZERO_MPU_GET_V_POSE}', 'pose'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_MPU_GET_V_ACCELERATION}', 'acceleration'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_MPU_GET_V_GYRO}', 'gyro'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_MPU_GET_V_MAGNETIC}', 'magnetic']
      ]
    }
  ],
  output: 'Number',
  style: 'sensor_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_MPU_GET_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifzero_mpu_get'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifzero_mpu_get'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzeroMpu9250 = 'import ifzeroMpu9250'
  let dropdownMpu = block.getFieldValue('MPU')
  let code = `ifzeroMpu9250.${dropdownMpu}()`
  return [code, Blockly.Python.ORDER_ATOMIC]
}
